import { IProlongAndHoldSubscriptionError as IProlongAndHoldSubscriptionError } from './types';

export const DEFAULT_RESULT: IProlongAndHoldSubscriptionError = {
  isSuccess: false,
  message: 'Сервер не отвечает. Попробуйте повторить попытку позднее',
};
